import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import BreadCrumb from 'components/BreadCrumb';
import ProductControls from 'components/ProductControls';
import ProductPrices from "components/ProductPrices";
import Metas from 'components/Metas';
import Description from "components/Product/Description";
import Gallery from "components/Product/Gallery";
import Loader from "components/Loader";
import TechnicalTable from 'components/Product/TechnicalTable';
import ProductFlags from 'components/ProductFlags';
import FabSocialSharing from 'components/FabSocialSharing';
import NutritionalTable from 'components/Product/NutritionalTable';
import TagManagerService from 'services/TagManager';
import { slugify } from 'utils';
import PubSub from 'services/PubSub/';
import {translateFlag} from 'config/constants';
import style from './style.scss';//NOSONAR

let actions = [];
let socialSharingSettings = {};
let technical = "";
let idProduct = null;

const Product = (props) => {

    const [inCart, setInCart] = useState(0);
    const [isMobile, setMobile] = useState(false);

    const {product, isLoaded} = props;
    const item = product ? product.items[0] : null;
    const skuData = (product && product.SkuData && product.SkuData[item.itemId]) ? product.SkuData[item.itemId] : {};
    const complementName = product ? product.items[0].complementName : null;
    const title = product ? product.productTitle || `${product.productName} | Jumbo.cl` : '';
    const description = product ? product.metaTagDescription || title : '';
    idProduct = item ? item.itemId : null;

    let controlsConfig = item ? {
        unitMultiplier: item.unitMultiplier,
        measurementUnit: item.measurementUnit,
        unitSale: (product['Pesable x Unidad'] && product['Pesable x Unidad'][0]) ? translateFlag[product['Pesable x Unidad'][0]] : false,
        maxItems: (item.maxItems) - inCart,
        buyTitle: "Agregar",
        listTitle: 'Guardar',
        listButton: true,
        tagManagerData: { product: product},
        addToCartCallback: (quantity) => {
            TagManagerService.addToCart(product, quantity);
        }
    } : {};


    let pricesSettings = {
        promotionDescription: true
    };

    useEffect(() => {
        actions.push(PubSub.register('cart_update', _updateInCart));
        if (!product && isLoaded) {
            const search = window.location.pathname.replace('/', '').replace('/p', '');
            props.history.push(`/Sistema/404?ProductLinkNotFound=${search}`);
        }

        return function cleanup() {
            actions = actions.map(token => PubSub.unregister(token));
            actions = [];
            idProduct = null;
        };
    }, []);

    useEffect(() => {
        if(product && isLoaded){
            setTimeout(() => PubSub.dispatch('product_scroll', { product }),0);
        }

        if (!product && isLoaded) {
            const search = window.location.pathname.replace('/', '').replace('/p', '');
            props.history.push(`/Sistema/404?ProductLinkNotFound=${search}`);
        }
    }, [product, isLoaded]);

    const getCrumbs = () => {
        if (!product) return [];

        const categories = product.categories.map((category) => {
            return category.split('/').filter(String);
        }).reverse();
        return categories.map((categories) => {
            return {
                title: categories.slice(-1).pop(),
                url: `/${categories.map((category) => {
                    return slugify(category)
                }).join("/")}/`
            }
        });
    }

    useEffect(() => {

        if (window) {
            checkViewport();
            window.addEventListener("resize", checkViewport);
        }


        return function cleanup() {

            if (window) {
                window.removeEventListener("resize", checkViewport);
            }
        }
    }, []);

    const checkViewport = () => {
        if (!document) return false;
        const $body = document.querySelector('body');
        const viewportWidth = $body.clientWidth;
        const currentIsMobile = viewportWidth < 1024;

        setMobile(currentIsMobile);

    };

    const _updateInCart = () => {
        if (!(window && window.orderItems && idProduct)) return false;
        const item = window.orderItems[idProduct];
        const quantity = item ? item.quantity : 0;
        
        setInCart(quantity);
    }

    const hasStock = (item) => {
        if (!item) return false;
        const commertialOffer = (item.sellers && item.sellers[0]) ? item.sellers[0].commertialOffer : false;
        return commertialOffer && commertialOffer.ListPrice !== 0;
    }

    const hasStockProduct = hasStock(item);
    const crumbs = getCrumbs();
    const flags = <ProductFlags item={item} nutritionalTag={true}/>;

    if (item) {
        item.sellerId = item.sellers[0] ? item.sellers[0].sellerId : null;
    }

    return (
        <>
            {product && <Metas>
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta name="Abstract" content={description} />

                <meta property="og:url" content={window.location.href} />
                <meta property="og:title" content={product.productName} />
                <meta property="og:description" content={(product.brand + ' | ' + 'Código de producto: ' + product.productReference)} />
                <meta property="og:image" content={(item && item.images && item.images[0])? item.images[0].imageUrl : "https://www.jumbo.cl/uploads/2019/04/logoJumbo.jpeg"} />
                <meta property="og:type" content="article" />
                <meta property="fb:app_id" content="30408486720" />

                <meta name="twitter:card" content="summary" />
                <meta name="twitter:site" content="@JumboChile" />
                <meta name="twitter:title" content={product.productName} />
                <meta name="twitter:description" content={(product.brand + ' | ' + 'Código de producto: ' + product.productReference)} />
                <meta name="twitter:image" content={(item && item.images && item.images[0])? item.images[0].imageUrl : "https://www.jumbo.cl/uploads/2019/04/logoJumbo.jpeg"} />

            </Metas>}

            {!product && <Loader className={'product-page-loader'} />}
            {product && <div className="container">
                <BreadCrumb crumbs={crumbs} />
                <main className="product-content">
                    <div className="product-info">
                        <div className="product-image-container">
                            <div className={'product-image-wrapper'}>
                                {isMobile && <FabSocialSharing settings={socialSharingSettings} product={product} />}
                                <Gallery images={item.images} flags={flags}/>
                                
                            </div>
                        </div>
                        <div className="product-info-wrapper">
                            <div className="product-info-flag-ofert">{flags}</div>
                            <div className="product-container-title">
                                <h1 className={'product-name'}>{product.productName}</h1>
                            </div>
                            <div className="product-aditional-info">
                                <div className="aditional-info">
                                    <span className="product-single-unit">{item.unitMultiplier} {item.measurementUnit}</span>
                                    <span className="product-brand">{product.brand}</span>
                                </div>

                                <div className="aditional-info">
                                    <span className="product-code">Código: {product.productReference}</span>
                                    {!isMobile && <FabSocialSharing settings={socialSharingSettings} product={product} tooltip={'Compartir producto'}/> }
                                </div>
                            </div>
                            {hasStockProduct && <ProductPrices item={item} skuData={skuData} settings={pricesSettings} productDetail={true}/>}
                            
                            {complementName && <div className="product-main-description">
                                <span className="product-main-description-title">Características principales: </span>
                                <ProductFlags item={item} nutritionalTag={false}/>
                                <span className="product-main-description-short" dangerouslySetInnerHTML={{ __html: complementName }}></span>
                            </div>}

                            {!complementName && <div className="product-main-description">
                                <ProductFlags item={item} nutritionalTag={false} customTitle="Características principales:"/>
                            </div>}
                            
                            {hasStockProduct && <ProductControls id={item.itemId} seller={item.sellerId} config={controlsConfig} quantity={item.quantity} inCart={item.inCart}/>}

                            {!hasStockProduct && <div className={'no-stock'}>
                                <i className={'font-icn alert'}></i>
                                <span className={'no-stock-text'}>En estos momentos, este artículo se encuentra sin stock.</span>
                            </div>}
                        </div>
                    </div>
                    <Description description={product.description} technical={technical} />
                    <NutritionalTable product={product} />
                    <TechnicalTable product={product} />
                </main>
            </div>}
        </>
    )
}

Product.propTypes = {
    product: PropTypes.object,
    history: PropTypes.object,
    isLoaded: PropTypes.bool
};

export default Product;
